import { useMobileMode } from '@redneckz/wildless-cms-uni-blocks/lib/hooks/useMobileMode';
import { Heading } from '@redneckz/wildless-cms-uni-blocks/lib/ui-kit/Heading/Heading';
import { Paragraph } from '@redneckz/wildless-cms-uni-blocks/lib/ui-kit/Paragraph/Paragraph';
import { Text } from '@redneckz/wildless-cms-uni-blocks/lib/ui-kit/Text/Text';
import React from 'react';

const PHONE_NUMBERS = ['+ 7 (495) 221-51-25', '+ 7 (495) 221-51-24'];

export const JournalistInfo = ({ className = '' }: { className?: string }) => {
  const isMobile = useMobileMode();

  return (
    <div className={className}>
      <Heading className="mb-m" headingType={isMobile ? 'h4' : 'h6'} as="h4">
        Для журналистов
      </Heading>
      <div className="pb-xs">
        <Text size="text-s" color="text-secondary-text" font="font-light">
          Телефон
        </Text>
      </div>
      {PHONE_NUMBERS.map((value, index) => (
        <Paragraph key={String(index)} size="text-l" color="text-primary-text">
          <a href={`tel:${cleanPhoneNumber(value)}`} className="hover:text-primary-main">
            {value}
          </a>
        </Paragraph>
      ))}
      <div className="pt-xs">
        <Text size="text-s" color="text-secondary-text" font="font-light">
          E-mail
        </Text>
      </div>
      <Paragraph size="text-l" color="text-primary-text">
        <a href="mailto:press@rshb.ru" className="hover:text-primary-main">
          press@rshb.ru
        </a>
      </Paragraph>
    </div>
  );
};

const cleanPhoneNumber = (phone: string) => phone.replace(/\D/g, '');
